export default {
      id: "icon-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#icon-usage",
      toString: function () {
        return this.url;
      }
    }